var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75668 0C3.76273 0 0.513428 3.2493 0.513428 7.24321C0.513428 12.1998 6.99543 19.4763 7.2714 19.7837C7.53062 20.0724 7.9832 20.0719 8.24195 19.7837C8.51793 19.4763 14.9999 12.1998 14.9999 7.24321C14.9999 3.2493 11.7506 0 7.75668 0Z",
    fill: "#8D5CE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.337150e7eb8bcdf8c53e0c5c8bf17d77.svg";
export { ForwardRef as ReactComponent };